<template>
  <div>
    <table class="custom-table responsive-table border-collapse">
      <thead class="font-normal">
        <tr class="shadow-table rounded-lg opacity-50">
          <th>ACCOUNT</th>
          <th>ACCT. CATEGORY</th>
          <th>GROUP</th>
          <th>ACCT. NAME</th>
          <th>DESCRIPTION</th>
          <th>CODE</th>
          <th>FIN. REPORT</th>
          <th>SUB-GROUP DESC.</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="rounded-lg bg-white"
          v-for="i in [1, 2, 3, 4, 5, 6, 7]"
          :key="i"
        >
          <td>Account Receivable</td>
          <td>Asset</td>
          <td>Current Assets</td>
          <td>All Receivables</td>
          <td>Outstanding receipts from...</td>
          <td>001</td>
          <td>Balance Sheet</td>
          <td>Account receivable is money owed...</td>
        </tr>
      </tbody>
    </table>

    <div class="py-3 px-3 bg-white flex justify-between rounded">
      <span class=" text-primary-yellow">Total</span>
      <span>2,250,450.50</span>
    </div>
    <!-- <EmptyContent v-if="!bookings.length" /> -->
  </div>
</template>

<script>
//   import EmptyContent from "../UI/EmptyContent.vue";

export default {
  props: ["bookings"],
  components: {},
  data() {
    return {
      showFilterModal: false,
      collectPaymentModal: false,
      selectedRowId: -1,
      shareLinkModal: false,
      totalCost: 0,
      transactionId: null,
      shippingId: "",
      paylink: "",
      email: "",
      payAmount: "",
    };
  },
  computed: {
    paymentParams() {
      return {
        paylink: this.paylink,
        email: this.email,
        payAmount: this.payAmount,
      };
    },
  },
  methods: {
    collectPaymentModalFunc(val) {
      this.totalCost = val?.transaction?.totalValue;
      this.transactionId = val?.transaction?.id;
      this.shippingId = val?.id;
      this.collectPaymentModal = true;
    },
    transactionRoute(val) {
      if (!val) return;
      localStorage.setItem("billing_reciept", "recievable");
      this.$router.push({ name: "BCM_reciept", params: { id: val } });
    },
    sharelinkModalFunc(val) {
      this.payAmount = val?.transaction?.totalValue;
      this.email = val?.transaction?.id;
      this.paylink = val?.id;
      this.shareLinkModal = true;
    },
    statusBg(val) {
      let bg = "";
      switch (val) {
        case "pending":
          bg = "text-red-500";
          break;
        case "not paid":
          bg = "text-red-500";
          break;
        case "draft":
          bg = "text-red-500";
          break;
        case "paid":
          bg = "text-teal-500";
          break;
        case "estimate":
          bg = "text-primary-yellow";
          break;

        default:
          bg = "text-teal-500";
          break;
      }
      return bg;
    },
  },
};
</script>

<style lang="scss" scoped>
.actions {
  @apply w-auto absolute right-0 bg-white shadow-md z-10 py-3 px-2;
  min-width: 200px;
}
.actions div {
  @apply flex w-full py-2 px-2 items-center;
}
.icon {
  width: auto;
  padding-right: 5px;
}
th {
  font-weight: 300;
}
</style>
